import React, { useEffect, useState } from "react";
import { Form, Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Input } from "antd";
import Dashboard from "../pages/Dashboard";
import ApiUtil from "../api/ApiUtil";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    try {
      const response = await ApiUtil.SendAsync({
        url: "/admin/signin",
        method: "POST",
        data: { email, password },
      });

      console.log("response : ", response.data.data);

      if (response && response.data && response.data.data) {
        localStorage.setItem("user", JSON.stringify(response.data.data));
        toast.success("Login successful!");
        navigate("/admin");
      } else {
        toast.error("Login failed. Please check your email and password.");
      }
    } catch (error) {
      console.error("Login error:", error);
      
      // Display appropriate error message
      if (error.message) {
        toast.error(`Login failed: ${error.message}`);
      } else if (error.data && error.data.message) {
        toast.error(`Login failed: ${error.data.message}`);
      } else {
        toast.error("Login failed. Please check your credentials and try again.");
      }
    }
  };

  return (
    <div className="">
      <br />
      <br />
      <div class="container mt-5 ">
        <div class="row justify-content-center ">
          <div class="col-md-6 form-card">
            <div class="card cardform p-3">
              <div class="card-header bg-white">
                <h2 class="text-center">Login</h2>
                <p className="text-center">
                  Login to your account to continue.
                </p>
              </div>

              <div class="card-body">
                <form>
                  <div class="form-floating mb-3">
                    <input
                      type="email"
                      class="form-control"
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="name@example.com"
                    />
                    <label for="floatingInput">Email address</label>
                  </div>

                  <div class="form-floating">
                    <input
                      type="password"
                      class="form-control"
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                    />
                    <label for="floatingPassword">Password</label>
                  </div>

                  <hr />
                  {/* <div className="mb-3 text-end">
                    <Link to="forgot-password" className="">
                      Forgot Password?
                    </Link>
                  </div> */}

                  <button
                    className="border-0 px-3 py-2 text-white fw-bold w-100 text-center text-decoration-none fs-5 mt-3"
                    style={{ background: "#e67929" }}
                    onClick={(e) => handleLogin(e)}
                  >
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Login;
